import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { ListColumnTitle } from '@app-models/list-column-title';
import * as _ from 'lodash';

@Component({
  selector: 'app-skeleton-list',
  templateUrl: './skeleton-list.component.html',
  styleUrls: ['./skeleton-list.component.scss'],
})
export class SkeletonListComponent implements OnInit {
  @Input() height: string;
  @Input() count: number;

  @Input() columns: ListColumnTitle[];

  constructor(public breakpointObserver: BreakpointObserver) {}

  public placeholderArray = [];
  isXSmall = false;
  isSmall = false;
  isMedium = false;
  isLarge = false;

  columnsToRender = [];

  cssClass: any;

  ngOnInit(): void {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
      ])
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.isXSmall = true;
          this.isSmall = false;
          this.isMedium = false;
          this.isLarge = false;
        }
        if (result.breakpoints[Breakpoints.Small]) {
          this.isXSmall = false;
          this.isSmall = true;
          this.isMedium = false;
          this.isLarge = false;
        }
        if (result.breakpoints[Breakpoints.Medium]) {
          this.isXSmall = false;
          this.isSmall = false;
          this.isMedium = true;
          this.isLarge = false;
        }
        if (result.breakpoints[Breakpoints.Large]) {
          this.isXSmall = false;
          this.isSmall = false;
          this.isMedium = false;
          this.isLarge = true;
        }
        if (result.breakpoints[Breakpoints.XLarge]) {
          this.isXSmall = false;
          this.isSmall = false;
          this.isMedium = false;
          this.isLarge = true;
        }
        this.calculateColumnsContainer();
      });
    for (let index = 0; index < this.count; index++) {
      this.placeholderArray.push(index + 1);
    }
  }

  calculateColumnsContainer() {
    let columns = [];
    if (this.isMedium || this.isLarge) {
      const filteredColumns = _.filter(
        this.columns,
        (item) => item.showIsDesktop
      );
      columns = _.map(filteredColumns, _.property('columnSizeDesktop'));
    }
    if (this.isSmall) {
      const filteredColumns = _.filter(
        this.columns,
        (item) => item.showIsTablet
      );
      columns = _.map(filteredColumns, _.property('columnSizeTablet'));
    }
    if (this.isXSmall) {
      const filteredColumns = _.filter(
        this.columns,
        (item) => item.showIsMobile
      );
      columns = _.map(filteredColumns, _.property('columnSizeMobile'));
    }
    const gridColumnTemplateArray = _.map(columns, (item, index) => {
      this.columnsToRender.push(index);
      return item + 'fr';
    });
    this.columnsToRender.pop();
    const gridColumnTemplate = _.join(gridColumnTemplateArray, ' ');
    const cssClass = {
      display: 'grid',
      'grid-template-columns': gridColumnTemplate,
    };
    this.cssClass = cssClass;
  }
}
